import {Action, ActionReducer, createReducer, on} from '@ngrx/store';
import {GeneralDimensionsState} from './generalDimensions';
import {
  loadGeneralDimensions,
  loadGeneralDimensionsSuccess,
  loadPublicGeneralDimensions,
  loadPublicGeneralDimensionsSuccess,
  updateGeneralDimensions,
  updateGeneralDimensionsSuccess
} from './generalDimensions.actions';
import {TypedAction} from '@ngrx/store/src/models';
import {Serializer, Serializers} from '../../interfaces/serializer';
import {GeneralDimension} from '../../interfaces/dimensions';
import {DimensionComponentObject, DimensionComponentObjects} from '../../classes/dimension-component-object';
import {Sort} from '../../libraries/sort';

const _reducer: ActionReducer<GeneralDimensionsState> = createReducer(
  {
    serialized: [],
    componentObjects: [],
    loading: false,
    loaded: false
  },
  on(loadGeneralDimensions, (state: GeneralDimensionsState): GeneralDimensionsState => {
    return {
      ...state,
      loading: true,
      loaded: false
    }
  }),
  on(loadGeneralDimensionsSuccess, (state: GeneralDimensionsState, action: TypedAction<string> & { dimensions: Serializers<GeneralDimension> }): GeneralDimensionsState => {
    return {
      ...state,
      serialized: action.dimensions,
      componentObjects: _sort(action.dimensions.map((dimension: Serializer<GeneralDimension>): DimensionComponentObject => new DimensionComponentObject(dimension))),
      loading: false,
      loaded: true
    };
  }),
  on(loadPublicGeneralDimensions, (state: GeneralDimensionsState): GeneralDimensionsState => {
    return {
      ...state,
      loading: true,
      loaded: false
    }
  }),
  on(loadPublicGeneralDimensionsSuccess, (state: GeneralDimensionsState, action: TypedAction<string> & { dimensions: Serializers<GeneralDimension> }): GeneralDimensionsState => {
    return {
      ...state,
      serialized: action.dimensions,
      componentObjects: action.dimensions.map((dimension: Serializer<GeneralDimension>): DimensionComponentObject => new DimensionComponentObject(dimension)),
      loading: false,
      loaded: true
    };
  }),
  on(updateGeneralDimensions, (state: GeneralDimensionsState): GeneralDimensionsState => {
    return {
      ...state,
      loading: true,
      loaded: false
    }
  }),
  on(updateGeneralDimensionsSuccess, (state: GeneralDimensionsState, action: TypedAction<string> & { dimensions: Serializers<GeneralDimension> }): GeneralDimensionsState => {
    action.dimensions.forEach((dimension: Serializer<GeneralDimension>): void => {
      const componentObject: DimensionComponentObject = state.componentObjects.find((componentObject: DimensionComponentObject): boolean => componentObject.payload.id === dimension.id);

      if (componentObject) {
        componentObject.update(dimension);
      } else {
        state.componentObjects.push(new DimensionComponentObject(dimension));
      }
    });

    return {
      ...state,
      serialized: action.dimensions,
      componentObjects: _sort(state.componentObjects),
      loading: false,
      loaded: true
    };
  })
);

export const generalDimensionsReducer: ActionReducer<GeneralDimensionsState> = (state: GeneralDimensionsState, action: Action) => {
  return _reducer(state, action);
};

function _sort(dimensions: DimensionComponentObjects): DimensionComponentObjects {
  return [
    ...dimensions.sort((a: DimensionComponentObject, b: DimensionComponentObject): number => Sort.alphaAsc(a.payload.attributes.name, b.payload.attributes.name))
  ];
}
